import { ValueOpt } from "best-common-react";
import { StateCreator, create } from "zustand";
import { AddItemsPayload as AddItemsModePayload, EnterEditModePayload, EyeballTrainingType } from "../types/Eyeball";
import { sendIframeAddItemsModeMsg, sendIframeEditMsg, sendIframeResetEditModeMsg } from "../utils/EyeballUtil";

export const ALL_AUTHENTICATORS_FILTER_OPTION: ValueOpt<number> = {
  value: -1,
  label: "All Authenticators",
};

type State = {
  iframeUrl: string;
  editingSessionAuthenticatorId: number;
  editMode: boolean;
  editItemId: number;
  eyeballSyncing: boolean;
  refreshReview: boolean;
  selectedAuthenticator: ValueOpt<number>;
  training?: EyeballTrainingType.REVIEW;
};

type Actions = {
  enterEditMode: (enterEditModePayload: EnterEditModePayload) => Promise<void>;
  exitEditMode: () => Promise<void>;
  enterAddItemsMode: (addItemsModePayload: AddItemsModePayload) => Promise<void>;
  setEyeballSyncing: (eyeballSyncing: boolean) => void;
  setRefreshReview: (refreshReview: boolean) => void;
  setSelectedAuthenticator: (authenticator: ValueOpt<number>) => void;
  setTraining: (training?: EyeballTrainingType.REVIEW) => void;
  resetGameReviewStore: () => void;
};

type GameReviewStore = State & Actions;

const initialState: State = {
  iframeUrl: window.MLBBest.envVariables.EYEBALL_APP_URL ?? "",
  editingSessionAuthenticatorId: -1,
  editMode: false,
  editItemId: -1,
  eyeballSyncing: false,
  refreshReview: false,
  selectedAuthenticator: ALL_AUTHENTICATORS_FILTER_OPTION,
  training: undefined,
};

const createGameReviewStore: StateCreator<GameReviewStore, [], [], GameReviewStore> = (set) => ({
  ...initialState,
  enterEditMode: async (enterEditModePayload: EnterEditModePayload) => {
    // Don't set state yet - wait for EDIT_STARTED confirmation from Eyeball
    // State will be updated when we receive EDIT_STARTED message in WrapperProvider
    await sendIframeEditMsg(enterEditModePayload);
  },
  exitEditMode: async () => {
    set({ editMode: false, editItemId: -1, eyeballSyncing: false, refreshReview: false }),
      await sendIframeResetEditModeMsg();
  },
  enterAddItemsMode: async (addItemsModePayload: AddItemsModePayload) => {
    // Don't set state yet - wait for EDIT_STARTED confirmation from Eyeball
    // State will be updated when we receive EDIT_STARTED message in WrapperProvider
    await sendIframeAddItemsModeMsg(addItemsModePayload);
  },
  setEyeballSyncing: (eyeballSyncing: boolean) => set({ eyeballSyncing }),
  setRefreshReview: (refreshReview: boolean) => set({ refreshReview }),
  setSelectedAuthenticator: (authenticator: ValueOpt<number>) => set({ selectedAuthenticator: authenticator }),
  setTraining: (training?: EyeballTrainingType.REVIEW) => set({ training }),
  resetGameReviewStore: () => set({ ...initialState }),
});

const useGameReviewStore = create<GameReviewStore>()((...a) => ({
  ...createGameReviewStore(...a),
}));

export default useGameReviewStore;
